<template>
  <div>
    <template v-if="travelServiceOrderItem.comment !== null && travelServiceOrderItem.comment.length > 0">
      {{ $t("global.comment") }}: {{ travelServiceOrderItem.comment }}<br />
    </template>
    <h3>{{ $t("global.passengers") }}</h3>
    <ul>
      <template v-for="passenger in travelServiceOrderItem.passengers">
        <li :key="passenger.id" style="text-transform: capitalize">{{ passenger.name }} {{ passenger.surname }}</li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: "TravelServiceOrderItemCommonTooltipPart",
  props: {
    travelServiceOrderItem: { required: true, type: Object }
  }
};
</script>

<style scoped></style>
